export const seoArticlesData = [
  {
    id: "crm-guide",
    categoryId: "crm",
    category: "CRM Sistemleri",
    title: "Kurumsal CRM Mimarisi: Tekliften Tahsilata, Kasa ve Cari Limit Yönetimi",
    summary:
      "İşletmelerin teklif, sözleşme, sipariş, müşteri kredi limiti, risk puanı ve tahsilat süreçlerini tek bir merkezde toplayan web ve Windows masaüstü hibrit CRM yazılımı mimarisi.",
    sections: [
      {
        heading: "1. Teklif ve Satış Sözleşmesi Hazırlama Döngüsü",
        text: "Kurumsal işletmelerde satışın en kritik adımı teklif hazırlama hızı ve doğruluğudur. SC Dijital CRM altyapısında, satış temsilcileri müşteri bazlı iskonto oranlarına göre dakikalar içinde PDF formatında profesyonel teklif ve satış sözleşmesi oluşturabilir. Teklifin onaylanması durumunda sistem tek bir butonla teklifi üretim veya tedarik siparişine dönüştürür. Çift veri girişi ortadan kalkar.",
        bullets: [
          {
            label: "Dinamik Şablon Motoru",
            desc: "Kurumsal kimliğinize uygun antetli teklif, sözleşme ve proforma fatura çıktısı üretimi.",
          },
          {
            label: "Revizyon ve Versiyon Takibi",
            desc: "Teklifte yapılan indirim, vade ve ürün değişikliklerinin loglanması ve geçmişe dönük kıyaslanması.",
          },
          {
            label: "Satış Ekibi Onay Hiyerarşisi",
            desc: "Belirli iskonto limitini aşan tekliflerin otomatik olarak satış direktörünün onayına düşmesi.",
          },
        ],
      },
      {
        heading: "2. Cari Risk, Kredi Limiti ve Açık Hesap Kontrolü",
        text: "Müşterilere vadeli satış yaparken tahsilat riskini minimize etmek için akıllı kredi limiti motoru devreye girer. Müşterinin mevcut vadesi geçmiş borçları, açık siparişleri ve çek/senet riskleri anlık hesaplanarak yeni sipariş aşamasında uyarı veya otomatik sipariş kilitleme uygulanır.",
        bullets: [
          {
            label: "Canlı Bakiye & Limit Metresi",
            desc: "Cari kart üzerinde kullanılan limit, kalan limit ve ödeme performans skoru anlık görselleştirilir.",
          },
          {
            label: "Masaüstü & Web Senkronizasyonu",
            desc: "Ofis içi muhasebe ekibi Windows masaüstü üzerinden işlem yaparken sahadaki ekip web ve mobilden erişir.",
          },
        ],
      },
      {
        heading: "3. Kasa, Banka ve e-Fatura İşlemleri",
        text: "Nakit, kredi kartı, havale ve dövizli (USD/EUR) kasalar anlık mutabakatla takip edilir. Kesilen e-Faturalar ve e-Arşiv belgeleri CRM ekranından tek tıkla görüntülenir, tahsilat makbuzları cari hesaba anında işlenir.",
      },
    ],
  },
  {
    id: "b2b-guide",
    categoryId: "b2b",
    category: "B2B Bayi Portalları",
    title: "B2B Bayi Sipariş ve Tahsilat Sistemi: Çoklu İskonto, Plasiyer ve Sanal POS",
    summary:
      "Toptan satış yapan imalatçı ve distribütörler için bayiye özel fiyat listesi, sepet, tekliften siparişe dönüşüm, cari ekstre ve taksitli tahsilat sunan B2B platformu.",
    sections: [
      {
        heading: "1. Bayiye ve Gruba Özel Fiyat Listeleri & İskonto Matrisi",
        text: "Toptan ticarette her bayinin iskonto oranı, vade şartı ve satın alma koşulları farklıdır. B2B yazılımımızda ana bayiler, alt bayiler ve bölgesel temsilciler için sınırsız sayıda fiyat listesi ve iskonto matrisi tanımlanabilir. Bayi sisteme giriş yaptığında yalnızca kendi net alış fiyatlarını ve stok durumunu görür.",
        bullets: [
          {
            label: "Kademeli Miktar İndirimleri",
            desc: "10 koli alımda %5, 50 koli alımda %12 gibi otomatik hacim iskontoları.",
          },
          {
            label: "Promosyon ve Kampanya Motoru",
            desc: "Sepette 10 al 1 bedava, belirli tutar üzeri ücretsiz kargo kurguları.",
          },
        ],
      },
      {
        heading: "2. Plasiyer (Saha Satış) ve Temsilci Modülü",
        text: "Plasiyerler kendi sorumlu oldukları bayilerin listesini görür, sahada müşteri adına sepet doldurup sipariş geçebilir. Cari hesap bakiyesini kontrol edebilir, vadesi gelen faturalar için müşterinin kredi kartından sanal POS ile taksitli tahsilat yapabilir.",
      },
      {
        heading: "3. Cari Ekstre, Açık Hesap ve Sanal POS Entegrasyonu",
        text: "Bayiler geçmiş faturalarını, ödemelerini ve kalan bakiyelerini PDF ekstre olarak alabilir. İyzico, PayTR veya banka sanal POS'ları üzerinden 3D Secure güvencesiyle 12 taksite varan tahsilat yapılabilir.",
      },
    ],
  },
  {
    id: "events-guide",
    categoryId: "events",
    category: "Etkinlik & Biletleme",
    title: "Bubilet ve Biletinial Standartlarında Etkinlik & Bilet Satış Platformu Mimarisi",
    summary:
      "Konser, tiyatro, festival ve spor müsabakaları için interaktif salon krokisi, koltuk seçimi, QR kodlu bilet iletimi ve kapı mobil barkod tarama altyapısı.",
    sections: [
      {
        heading: "1. İnteraktif Salon Krokisi ve Koltuk Seçimi (Seat Map Engine)",
        text: "Farklı salon, stadyum ve tiyatro planlarına göre SVG tabanlı interaktif koltuk seçim motoru. Kullanıcılar sahneye olan açılarını, kategori fiyatlarını ve dolu/boş koltukları anlık görerek rezervasyon yapar. Aynı koltuğun eşzamanlı iki kişi tarafından satın alınmasını önleyen WebSocket kilit mekanizması mevcuttur.",
        bullets: [
          {
            label: "Kategori ve Fiyatlandırma",
            desc: "Protokol, VIP, 1. Kategori, Balkon ve Ayakta gibi çoklu bilet tipleri.",
          },
          {
            label: "Kombine ve Sezonluk Bilet",
            desc: "Birden fazla etkinlik için ortak koltuk tanımlama ve abonelik sistemi.",
          },
        ],
      },
      {
        heading: "2. SMS ve E-Posta ile Anlık QR Kodlu Bilet Gönderimi",
        text: "Ödeme sanal POS üzerinden tamamlandığı anda alıcıya benzersiz şifreli QR kod üretilir. QR kod SMS linki ve PDF e-posta eki olarak saniyeler içinde iletilir. Sahte veya kopyalanmış bilet üretimi kriptografik imzalama ile engellenir.",
      },
      {
        heading: "3. Kapı Giriş Kontrolü (Mobil QR Barkod Tarayıcı)",
        text: "Etkinlik alanındaki görevliler, iOS veya Android telefonlarının kamerasıyla gelen ziyaretçilerin QR biletlerini okutur. Giriş yapıldığı anda bilet 'Kullanıldı' olarak işaretlenir ve mükerrer girişler sesli/görsel ikazla anında durdurulur. İnternet kesilse bile yerel eşitlemeyle çalışabilir.",
      },
    ],
  },
  {
    id: "ecommerce-guide",
    categoryId: "b2b",
    category: "E-Ticaret & Sanal Mağaza",
    title: "Yüksek Trafik Uyumlu B2C E-Ticaret ve Omnichannel Alışveriş Mimarisi",
    summary:
      "Sıfırdan kodlanan, hızlı yüklenen, sepet terk oranını düşüren, kargo barkodu ve otomatik e-fatura kesen kurumsal e-ticaret altyapısı.",
    sections: [
      {
        heading: "1. Hız ve Arama Motoru Optimizasyonu (Core Web Vitals)",
        text: "Hazır hantal şablonların aksine, saf Vue.js ve optimize CSS ile 1 saniyenin altında açılan e-ticaret mağazaları kodluyoruz. Google PageSpeed skoru 90+ seviyesinde kalarak organik aramalarda en üst sıralarda yer almanızı sağlar.",
      },
      {
        heading: "2. Sepet, Ödeme ve Kargo Entegrasyonu",
        text: "Müşterinin tek sayfada teslimat adresi girdiği, kargo firmasını seçtiği ve 3D Secure ile ödemeyi tamamladığı akıcı checkout akışı. Yurtiçi Kargo, MNG, Aras ve Sürat Kargo API'leri ile otomatik kargo takip fişi üretimi.",
      },
    ],
  },
  {
    id: "mobile-guide",
    categoryId: "mobile",
    category: "Mobil & ERP",
    title: "Kurumsal B2B Mobil Uygulama ve Saha Operasyon Mimarisi (iOS & Android)",
    summary:
      "Oyun içermeyen; tamamen B2B sipariş, saha satış temsilcisi, depo sayım ve barkod okuma odaklı kurumsal iOS ve Android mobil çözümleri.",
    sections: [
      {
        heading: "1. Neden Oyun Değil, Saf Kurumsal Mobil Çözüm?",
        text: "SC Dijital olarak mobil uygulama odağımız yalnızca şirketlerin operasyonel verimliliğini artırmaktır. Bayilerin cep telefonundan sipariş vermesi, saha plasiyerlerinin müşteriyi ziyaret edip tablet üzerinden tahsilat yapması ve depo personelinin sevkiyat barkodu okutması gibi süreçleri kodluyoruz.",
        bullets: [
          {
            label: "Offline Sipariş Taslağı",
            desc: "İnternet çekmeyen depolarda veya bodrum katlarda sipariş kaydedilir, internet gelince sunucuya aktarılır.",
          },
          {
            label: "Kamera ile Barkod & Karekod Okuma",
            desc: "Ürün kolisindeki barkodu okutarak anında sepete ekleme ve fiyat görme.",
          },
          {
            label: "Anlık Push Bildirimleri",
            desc: "Sipariş onaylandı, kargoya verildi veya yeni kampanya başladı bildirimleri.",
          },
        ],
      },
    ],
  },
  {
    id: "pos-guide",
    categoryId: "integrations",
    category: "Sanal POS & Finans",
    title: "Sanal POS ve Banka Ödeme Entegrasyonları: İyzico, PayTR ve 3D Secure 2.0",
    summary:
      "Web sitelerine, CRM panellerine ve B2B portallarına banka ve ödeme kuruluşu API'lerinin güvenli, taksit destekli ve anında iade/iptal özellikleriyle entegrasyonu.",
    sections: [
      {
        heading: "1. 3D Secure 2.0 ve Dolandırıcılık (Fraud) Koruması",
        text: "Müşterinin kredi kartı güvenliğini sağlayan SMS onaylı 3D Secure 2.0 altyapısı. Ters ibraz (chargeback) riskini sıfıra indiren kurumsal mimari.",
      },
      {
        heading: "2. Çoklu Banka Taksit Motoru",
        text: "Bonus, World, Maximum, Axess, CardFinans, Paraf ve Bankkart logolu tüm kredi kartları için vade farkı veya peşin fiyatına taksit seçeneklerinin otomatik hesaplanması.",
      },
    ],
  },
  {
    id: "accounting-guide",
    categoryId: "integrations",
    category: "Muhasebe Entegrasyonu",
    title: "Muhasebe & e-Belge Entegrasyonları: Uyumsoft, Paraşüt ve Logo Yazılım Hattı",
    summary:
      "Cari kart, sipariş, fatura, stok ve e-Fatura / e-Arşiv belgelerinin resmi muhasebe sistemine çift yönlü aktarımı ve otomatik senkronizasyonu.",
    sections: [
      {
        heading: "1. Uyumsoft & Paraşüt e-Fatura / e-Arşiv Hattı",
        text: "E-ticaret veya CRM üzerinden onaylanan bir siparişin faturası tek tıkla Uyumsoft veya Paraşüt resmi portalına gönderilir, GİB onaylı e-Fatura PDF'i oluşturulup müşteriye otomatik iletilir.",
        bullets: [
          {
            label: "Çift Yönlü Stok ve Fiyat Eşleme",
            desc: "Muhasebede değişen ürün fiyatı veya azalan stok anında web sitesine ve CRM'e yansır.",
          },
          {
            label: "Cari Bakiye Senkronizasyonu",
            desc: "Muhasebeye girilen banka havalesi B2B ekranında bayinin bakiyesinden anında düşer.",
          },
        ],
      },
    ],
  },
  {
    id: "alotech-guide",
    categoryId: "alotech",
    category: "Çağrı Merkezi & CTI",
    title: "AloTech Çağrı Merkezi ve CTI Santral Entegrasyonu: Ekranda Müşteri Tanıma",
    summary:
      "AloTech bulut santral API'si ile gelen çağrıda ekranda anında müşteri kartının açılması, tek tıkla arama yapılması ve ses kayıtlarının CRM'e işlenmesi.",
    sections: [
      {
        heading: "1. Anında Müşteri Tanıma (CTI Screen Pop-up)",
        text: "Bir müşteri aradığında santral sinyali CRM ekranına düşer. Temsilcinin ekranında müşterinin adı, son siparişleri, bekleyen teklifleri ve güncel borç bakiyesi çağrı cevaplanmadan önce belirir. Böylece müşteri karşılaması kusursuzlaşır.",
      },
      {
        heading: "2. Tek Tıkla Arama (Click-to-Call) ve Ses Kayıtları",
        text: "CRM'deki müşteri kartında telefon numarasının yanındaki ahize ikonuna tıklandığında santral temsilcinin kulaklığını çaldırarak müşteriyi arar. Görüşme bittiğinde ses kaydı linki müşterinin işlem geçmişine otomatik iliştirilir.",
      },
    ],
  },
  {
    id: "erp-bom-guide",
    categoryId: "mobile",
    category: "Özel ERP & Üretim",
    title: "Özel ERP, Ürün Reçetesi (BOM) ve İmalat Yönetim Sistemleri",
    summary:
      "İmalatçı işletmeler için hammadde reçeteleri (Bill of Materials), iş emirleri, fason takip, depo ve satın alma onay hiyerarşisi.",
    sections: [
      {
        heading: "1. Ürün Reçeteleri (BOM) ve Hammadde İhtiyaç Planlaması",
        text: "Bir ürünün üretilmesi için gereken profil, vida, boya, sac, kumaş veya elektronik komponent miktarlarının tanımlanması. Sipariş geldiğinde gereken hammadde miktarının hesaplanması ve kritik stok uyarıları.",
      },
      {
        heading: "2. İş Emirleri ve Fason Operasyon Takibi",
        text: "Kesim, büküm, boyahane, montaj ve paketleme istasyonlarında iş emrinin hangi aşamada olduğunun canlı izlenmesi. Dışarıya fasona gönderilen yarı mamullerin giriş-çıkış kontrolü.",
      },
    ],
  },
];

export const seoCities = [
  "Kayseri",
  "İstanbul",
  "Ankara",
  "İzmir",
  "Bursa",
  "Gaziantep",
  "Konya",
  "Kocaeli",
  "Adana",
  "Denizli",
  "Antalya",
  "Eskişehir",
  "Samsun",
  "Trabzon",
  "Tekirdağ",
  "Manisa",
  "Sakarya",
  "Balıkesir",
  "Mersin",
  "Hatay",
  "Kahramanmaraş",
  "Diyarbakır",
  "Şanlıurfa",
  "Malatya",
  "Sivas",
  "Elazığ",
  "Aydın",
  "Muğla",
  "Çanakkale",
  "Kütahya",
  "Afyonkarahisar",
  "Uşak",
  "Isparta",
  "Burdur",
  "Nevşehir",
  "Niğde",
  "Aksaray",
  "Kırşehir",
  "Yozgat",
  "Kırıkkale",
  "Çorum",
  "Tokat",
  "Amasya",
  "Ordu",
  "Giresun",
  "Rize",
  "Zonguldak",
  "Karabük",
  "Bartın",
  "Kastamonu",
  "Düzce",
  "Bolu",
  "Yalova",
  "Edirne",
  "Kırklareli",
  "Erzurum",
  "Van",
  "Batman",
  "Mardin",
  "Osmaniye",
];

export const seoIndustries = [
  "Mobilya & Yatak İmalatı CRM",
  "Makine & Ekipman İmalatı ERP",
  "Tekstil & Konfeksiyon B2B",
  "Otomotiv Yedek Parça B2B Bayi Sistemi",
  "Metal Sanayi & Çelik Konstrüksiyon",
  "Gıda İmalatı & Dağıtım B2B",
  "Medikal & Sağlık Malzemeleri E-Ticaret",
  "İnşaat Malzemeleri & Hırdavat Bayi Sistemi",
  "Elektrik & Aydınlatma Toptan Sipariş",
  "Plastik & Ambalaj İmalat Takibi",
  "Kimya & Boya Sanayi Çözümleri",
  "Lojistik & Depo Yönetim Yazılımı",
  "Etkinlik & Festival Biletleme Platformu",
  "Çağrı Merkezi & Müşteri Hizmetleri CRM",
];
